export enum InsectIdSource {
  ONLINE_ALGORITHM = "ONLINE_ALGORITHM",
  OFFLINE_ALGORITHM = "OFFLINE_ALGORITHM",
  EXPERT_DECISION = "EXPERT_DECISION"
}
